module.exports = __webpack_public_path__ + "img/DSC04048.c1ecce9a.jpg";